// extracted by mini-css-extract-plugin
module.exports = {"policeBox":"policeplatform_policeBox__tekxU","tabBox":"policeplatform_tabBox__e_28E","policeplatform_banner":"policeplatform_policeplatform_banner__2QB80"};